import React from 'react'
import styled from 'styled-components'

// These two divs render the pink background for the AM hours and the blue background for the PM hours.

const Pink = styled.div`
  height: 50%;
  width: 100%;
  position: absolute;
  background-color: #FEF6F8;
  z-index: -400;
`
const Blue = styled.div`
  height: 50%;
  width: 100%;
  position: absolute;
  top: 50%;
  background-color: #EEFEFE;
  z-index: -4000;
  margin-left: -12rem;;
`

export default function UIPinkBlue () {
  // There is no need to create another node, just use a fragment to wrap the divs
  return (
    <>
      <Pink/>
      <Blue/>
    </>
  )
}